export const LOGIN_ROUTE = '/auth/login';
export const HOME_ROUTE = '/admin';
export const INDEX_ROUTE = '/';